import { render, staticRenderFns } from "./NominationsOverview.vue?vue&type=template&id=6718fe04&scoped=true&"
import script from "./NominationsOverview.vue?vue&type=script&lang=js&"
export * from "./NominationsOverview.vue?vue&type=script&lang=js&"
import style0 from "./NominationsOverview.vue?vue&type=style&index=0&id=6718fe04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718fe04",
  null
  
)

export default component.exports